import store from "@src/reducers/store";
import { updateActiveMachineStructureNode } from "@src/reducers/your-reducer";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";

export const filterMachineStructureNew = (filterInputContent) => {
  const logger = getLogger();
  const t0 = performance.now();
  logger.debug("t0 - start of action", t0);

  const nodeManager = getNodeManager();
  nodeManager.closeMachineStructureFilterModal();

  nodeManager.writeFilterInputContentToStoreInMachineFilterModal(
    filterInputContent,
  );

  const machineStructureNodeset = getMachineStructureNodeset();

  machineStructureNodeset.filterNodes(filterInputContent);
  machineStructureNodeset.setShowFilterPanel(true);

  nodeManager.closeNodeManagerDetailsPanel();
  store.dispatch(updateActiveMachineStructureNode(""));

  const t1 = performance.now();
  logger.debug("t1 - end of action", t1);
  logger.debug(
    `Action to filter machine list with new structure took ${
      t1 - t0
    } milliseconds.`,
  );
};
